import { Fragment, useContext, useEffect, useState } from 'react';
import { ViContext } from '../../context/ViContext';

import { IconButton } from '@mui/material';
import { Add as AddIcon, Clear as DeleteIcon } from '@mui/icons-material';
import { MapContext } from '../../context/MapContext';
import { extend } from 'ol/extent';

function TabMenu() {
	const { mapMode, tabInfoArr, setTabInfoArr, selectedTab, setSelectedTab } =
		useContext(ViContext);

	const { weightedMap, getFeatures } = useContext(MapContext);

	const [tabClass, setTabClass] = useState([]);

	useEffect(() => {
		let classArr = [];
		for (let i = 0; i < tabInfoArr.length; i++) {
			classArr.push('tab');
		}
		classArr[selectedTab] = classArr[selectedTab] + ' selectedTab';
		setTabClass(classArr);
	}, [tabInfoArr[selectedTab]]);

	const onClickTab = (e, idx) => {
		setSelectedTab(idx);
	};
	const onClickAddTab = (e) => {
		setTabInfoArr((pre) => {
			let addarr = pre;

			setSelectedTab(addarr.length);

			addarr[addarr.length] = {
				sidoCode: '',
				sggCode: '',
				emdCode: '',
				sidoName: '전국',
				sggName: '',
				emdName: '',
				pop: 1,
				consume: 1,
				prod: 1,
			};

			return addarr;
		});
	};

	const extentFeatures = (features) => {
		const extent = features[0].getGeometry().getExtent();
		if (features.length > 1) {
			for (let i = 1; i < features.length; i++) {
				extend(extent, features[i].getGeometry().getExtent());
			}
		}
		const mapSize = weightedMap.getSize();
		weightedMap.getView().fit(extent, mapSize);
	};

	const extentView = async (newValue) => {
		let features;
		if (tabInfoArr[newValue].emdCode) {
			features = await getFeatures(tabInfoArr[newValue].emdCode, 'amd_cd');
		} else if (tabInfoArr[newValue].sggCode) {
			features = await getFeatures(tabInfoArr[newValue].sggCode, 'sgg_cd');
		} else if (tabInfoArr[newValue].sidoCode) {
			features = await getFeatures(tabInfoArr[newValue].sidoCode, 'sido_cd');
		}
		extentFeatures(features);
	};

	const onClickDeleteTab = (e) => {
		e.stopPropagation();

		if (tabInfoArr.length > 1) {
			setTabInfoArr((pre) => {
				let delarr = pre;
				delarr.splice(selectedTab, 1);
				console.log(delarr);
				return delarr;
			});
		}

		if (selectedTab === tabInfoArr.length) {
			setSelectedTab((pre) => {
				const newValue = pre - 1;
				extentView(newValue);
				return newValue;
			});
		} else {
			// 컴포넌트 리렌더링을 위함
			setTabInfoArr([...tabInfoArr]);
			extentView(selectedTab);
		}
	};

	const getTabInfos = tabInfoArr.map((cur, idx) => {
		let selectedRegionName = tabInfoArr[idx].sidoName;
		if (cur.sggCode) {
			selectedRegionName += ` ${cur.sggName}`;
		}
		if (cur.emdCode) {
			selectedRegionName += ` ${cur.emdName}`;
		}
		// let tabClassName = 'tab';
		// if (selectedTab === idx) {
		//   tabClassName += ' selectedTab';
		// }

		return (
			<div
				className={tabClass[idx]}
				key={`${selectedRegionName}${idx}`}
				onClick={(e) => onClickTab(e, idx)}
			>
				{selectedRegionName}
				{idx === selectedTab && tabInfoArr.length > 1 ? (
					<IconButton onClick={(e) => onClickDeleteTab(e)}>
						<DeleteIcon sx={{ color: '#ffffff' }} />
					</IconButton>
				) : null}
				{idx === 0 ? (
					<span className="TooltipText">
						적용하기 버튼을 눌러 탭의 이름을 변경할 수 있습니다.
					</span>
				) : null}
			</div>
		);
	});

	return (
		<div className={mapMode === 'origin' ? 'tabMenu hidden' : 'tabMenu'}>
			{getTabInfos}
			<IconButton onClick={onClickAddTab}>
				<AddIcon sx={{ color: '#ffffff' }} />
			</IconButton>
		</div>
	);
}

export default TabMenu;
